module.exports = __webpack_public_path__ + "static/img/box4bg.c32c60d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/box4bg.png
// module id = pWuC
// module chunks = 0